import React, { useState } from 'react';
import { SectionWrapper } from './SectionWrapper';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQ() {
  const faqs = [{
    q: '¿Tengo que cocinar platos complicados?',
    a: 'No, son alimentos reales y sencillos que encuentras en cualquier mercado.'
  }, {
    q: '¿Voy a pasar hambre?',
    a: 'Al contrario, la proteína y grasas saludables te mantendrán saciada todo el día.'
  }, {
    q: '¿Puedo tomar café?',
    a: 'Sí, te enseñamos el momento exacto para tomarlo sin inflamar tu vientre.'
  }, {
    q: '¿Funciona si ya estoy en la menopausia?',
    a: 'Especialmente ahí es cuando más necesitas este protocolo hormonal.'
  }, {
    q: '¿Es un pago único?',
    a: 'Sí, pagas una vez y el material es tuyo para siempre.'
  }, {
    q: '¿Cuánto tiempo tardaré en ver resultados?',
    a: 'La desinflamación suele notarse entre el día 3 y el día 5.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <SectionWrapper className="bg-white" data-id="element-15">
      <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 text-charcoal" data-id="element-16">
        Preguntas Frecuentes
      </h2>
      <div className="space-y-4" data-id="element-17">
        {faqs.map((faq, index) => <div key={index} className="border border-gray-200 rounded-xl overflow-hidden bg-cream/30" data-id="element-18">
            <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" data-id="element-19">
              <span className="font-semibold text-lg text-charcoal font-sans" data-id="element-20">
                {faq.q}
              </span>
              <motion.div animate={{
            rotate: openIndex === index ? 180 : 0
          }} transition={{
            duration: 0.3
          }} data-id="element-21">
                <ChevronDown className="w-5 h-5 text-coral" data-id="element-22" />
              </motion.div>
            </button>
            <AnimatePresence data-id="element-23">
              {openIndex === index && <motion.div initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.3
          }} data-id="element-24">
                  <div className="px-6 pb-5 text-gray-600" data-id="element-25">{faq.a}</div>
                </motion.div>}
            </AnimatePresence>
          </div>)}
      </div>
    </SectionWrapper>;
}